import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-operation-dropdown',
  templateUrl: './operation-dropdown.component.html',
  styleUrls: ['./../dropdown.component.scss']
})
export class OperationDropdownComponent {
  @Input() options: Array<any>;
  @Input() isExtendedData: boolean;
  activeTitle: string;
  isDropDown: boolean;

  @Output() readonly selectedOption: EventEmitter<any> = new EventEmitter<any>();

  onToggle(): void {
    this.isDropDown = !this.isDropDown;
  }

  onSelectOption(option: any): void {
    if (this.isExtendedData) {
      this.activeTitle = option.client + '-' + option.workOrderName + '-' + option.workOrderUpisId + '-' + option.name;
    } else {
      this.activeTitle = option.name;
    }

    this.selectedOption.emit(option);
  }

  trackByFunction(index: number): number {
    return index;
  }
}
